export default function (Alpine) {
  Alpine.store('countdowns', {
    instances: {},

    registerCountdown(id, state) {
      this.instances[id] = state;
    },

    updateState(id, newState) {
      if (this.instances[id]) {
        this.instances[id] = { ...this.instances[id], ...newState };
      }
    },

    getState(id) {
      return this.instances[id] || {};
    }
  });

  Alpine.directive('countdown', (el, { expression }, { evaluate, cleanup }) => {
    const config = evaluate(expression) || {};
    let interval;

    const countdownId = `countdown-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
    el.dataset.countdownId = countdownId;

    const settings = {
      year: config.year,
      month: config.month,
      day: config.day,
      hours: config.hours || 0,
      minutes: config.minutes || 0,
      seconds: config.seconds || 0,
      separator: config.separator || ' ',
      showLabels: config.showLabels !== undefined ? config.showLabels : true,
      refresh: config.refresh || 1000,
      enableUtc: config.enableUtc || false
    };

    if (!settings.year || !settings.month || !settings.day) {
      console.error('Countdown requires year, month, and day to be set');
      return;
    }

    function getTimeRemaining() {
      const targetDate = settings.enableUtc
        ? new Date(Date.UTC(settings.year, settings.month - 1, settings.day, settings.hours, settings.minutes, settings.seconds))
        : new Date(settings.year, settings.month - 1, settings.day, settings.hours, settings.minutes, settings.seconds);

      const difference = targetDate - new Date();

      return {
        total: difference,
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    function updateCountdown() {
      const t = getTimeRemaining();

      Alpine.store('countdowns').updateState(countdownId, t);

      if (t.total <= 0) {
        const zeroParts = [
          settings.showLabels ? '000 days' : '000',
          settings.showLabels ? '00 hours' : '00',
          settings.showLabels ? '00 minutes' : '00',
          settings.showLabels ? '00 seconds' : '00',
        ];
        el.textContent = zeroParts.join(settings.separator);
        clearInterval(interval);
        return;
      }

      const parts = [
        { value: t.days, label: 'days' },
        { value: t.hours, label: 'hours' },
        { value: t.minutes, label: 'minutes' },
        { value: t.seconds, label: 'seconds' }
      ].map(({ value, label }) => {
        const paddedValue = value.toString().padStart(label === 'days' ? 3 : 2, '0');
        return settings.showLabels ? `${paddedValue} ${label}` : paddedValue;
      });

      el.textContent = parts.join(settings.separator);
    }

    Alpine.store('countdowns').registerCountdown(countdownId, getTimeRemaining());
    updateCountdown();
    interval = setInterval(updateCountdown, settings.refresh);

    cleanup(() => {
      clearInterval(interval);
      delete Alpine.store('countdowns').instances[countdownId];
    });
  });

  Alpine.directive('countdown-event', (el, { value, expression }, { evaluateLater, effect }) => {
    let getHandler = evaluateLater(expression);
    let endFired = false;

    effect(() => {
      const countdownEl = el.closest('[data-countdown-id]');
      const countdownId = countdownEl?.dataset.countdownId;

      if (!countdownId) {
        console.warn('countdown-event: No countdown instance found.');
        return;
      }

      const state = Alpine.store('countdowns').getState(countdownId);

      switch (value) {
        case 'end':
          if (state.total <= 0 && !endFired) {
            endFired = true;
            getHandler((callback) => {
              if (typeof callback === 'function') callback(state);
            });
          }
          break;
        case 'update':
          getHandler((callback) => {
            if (typeof callback === 'function') callback(state);
          });
          break;
      }
    });
  });

  Alpine.magic('countdown', (el) => {
    return new Proxy({}, {
      get(target, prop) {
        const countdownEl = el.closest('[data-countdown-id]');
        if (!countdownEl) return 0;

        const countdownId = countdownEl.dataset.countdownId;
        if (!countdownId) return 0;

        const state = Alpine.store('countdowns').getState(countdownId);
        return state[prop] || 0;
      }
    });
  });
}
